import { useContext } from 'react';
import { FiSettings } from 'react-icons/fi';
import { BiExit } from 'react-icons/bi';
import { useLogout } from '../../../config/connection/auth';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ROUTE } from '../../../config';
import { SidebarContext } from '../../../providers/SidebarProvider';
import { useReportContext } from '../../../providers/ReportContext';
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { Popover } from 'antd';
import { BarChartOutlined } from '@ant-design/icons';

function Header() {
    const { isOpen } = useContext(SidebarContext);
    const { isGeneratingReport, resumoHeader } = useReportContext();
    const navigate = useNavigate();
    const logout = useLogout();

    const exit = async () => {
        await logout.mutateAsync({});
        navigate(LOGIN_ROUTE);
    }

    const expandedClass: string = isOpen ? '' : '--collapse';

    return (
        <header className={"header"+expandedClass}>
            <div>
                <div className={resumoHeader ? 'header-left header-left--resumo' : 'header-left'}>
                    {/*
                      * Com o resumo rolado para fora da tela, os totais ocupam o
                      * lugar do titulo: e a informacao que o usuario precisa ter a
                      * mao enquanto percorre a tabela.
                      */}
                    {resumoHeader
                        ? (
                            <div className="header-resumo">
                                <Popover
                                    content={resumoHeader.graficos}
                                    trigger="click"
                                    placement="bottomLeft"
                                    overlayClassName="resumo-graficos-popover"
                                >
                                    <button type="button" className="resumo-graficos-trigger hoverable">
                                        <BarChartOutlined />
                                        Gráficos
                                    </button>
                                </Popover>
                                {resumoHeader.totais.map(item => (
                                    <div className="header-resumo-item" key={item.label}>
                                        <span className="header-resumo-label">{item.label}</span>
                                        <span className="header-resumo-valor">{item.valor}</span>
                                    </div>
                                ))}
                            </div>
                        )
                        : <span className='header-title'>Realiza</span>}
                </div>
                <div>
                    {isGeneratingReport && (
                        <div className="report-loading">
                            <AiOutlineLoading3Quarters className="loading-icon" />
                            <span>Gerando relatório...</span>
                        </div>
                    )}
                    <div className='header-section' onClick={exit}>
                        <div><BiExit /></div>
                        <p>Sair</p>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header;